import React, { useContext, useState } from 'react';
import { Accordion, Container, Nav, Navbar } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import kz_logo from '../../../../assets/images/kz_logo.png';
import UserInfoContext from '../../../utis/userInfoContext';
import SupportModal from '../../Modals/SupportModal';
import { useStats } from '../../Pages/Stats/StatsContext';

const SideBar = ({ setActive }) => {
    const [openSupport, setOpenSupport] = useState(false);
    const { pathname, hash } = useLocation();
    const { userInfoData } = useContext(UserInfoContext);
    const { statsData } = useStats();

    const isAdminRoute = pathname.startsWith('/admin');
    const isKdfRoute = pathname.includes('kdf-stats');
    const isLinkRoute = pathname.includes('tl-stats');

    const isWaitingForData =
        !userInfoData || Object.keys(userInfoData).length === 0;

    const userType = userInfoData?.user_type;

    const shouldShowAdminSection =
        isAdminRoute || (!isWaitingForData && [1, 2].includes(userType));

    const shouldShowSuperAdminLinks =
        userType === 1 || (isWaitingForData && isAdminRoute);

    const isDomainManagerRoute =
        pathname.includes('/admin/master_domains') ||
        pathname.includes('/admin/organization_domains') ||
        pathname.includes('/admin/get_domain_users');

    return (
        <>
            {openSupport && (
                <SupportModal
                    openSupport={openSupport}
                    setOpenSupport={setOpenSupport}
                />
            )}

            <Navbar expand="lg" className="bg-body-tertiary p-0 d-block">
                <Container fluid className="bg-white p-0">
                    <Navbar.Brand className="m-auto cursor-pointer">
                        <Link to="/kdfs">
                            <img src={kz_logo} alt="kz_logo" className="img-fluid" />
                        </Link>
                    </Navbar.Brand>
                </Container>

                <Container className="p-0 m-0">
                    <Nav className="flex-column w-100 sidebar-nav">

                        {/* ================= ADMIN ================= */}
                        {shouldShowAdminSection && (
                            <Accordion defaultActiveKey={isAdminRoute ? 'admin' : undefined}>
                                <Accordion.Item eventKey="admin">
                                    <Accordion.Header
                                        className={`menu-sidebar ${isAdminRoute ? 'active' : ''}`}
                                    >
                                        Admin
                                    </Accordion.Header>

                                    <Accordion.Body className="p-0">

                                        {shouldShowSuperAdminLinks && (
                                            <Nav.Link
                                                as={Link}
                                                to="/admin/orgs"
                                                className={pathname.includes('/admin/orgs') ? 'active' : ''}
                                            >
                                                Organizations
                                            </Nav.Link>
                                        )}

                                        <Nav.Link
                                            as={Link}
                                            to="/admin/users"
                                            className={pathname.includes('/admin/users') ? 'active' : ''}
                                        >
                                            Users
                                        </Nav.Link>

                                        {shouldShowSuperAdminLinks && (
                                            <Nav.Link
                                                as={Link}
                                                to="/admin/subscriptions"
                                                className={pathname.includes('/admin/subscriptions') ? 'active' : ''}
                                            >
                                                Subscriptions
                                            </Nav.Link>
                                        )}

                                        <Nav.Link
                                            as={Link}
                                            to="/admin/potential_bots"
                                            className={pathname.includes('/admin/potential_bots') ? 'active' : ''}
                                        >
                                            Potential Bots
                                        </Nav.Link>

                                        <Nav.Link
                                            as={Link}
                                            to="/admin/customization_log"
                                            className={pathname.includes('/admin/customization_log') ? 'active' : ''}
                                        >
                                            Customization Logs
                                        </Nav.Link>

                                        {userType === 1 ? <Nav.Link
                                                as={Link}
                                                to="/admin/master_domains"
                                                className={isDomainManagerRoute ? 'active' : ''}
                                            >
                                                Domains List
                                            </Nav.Link> :
                                            <Nav.Link
                                                as={Link}
                                                to={`/admin/organization_domains?company_id=${userInfoData?.company?.id}`}
                                                className={isDomainManagerRoute ? 'active' : ''}
                                            >
                                                Domains List
                                            </Nav.Link>}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        )}

                        {/* ================= MAIN MENU ================= */}
                        <Nav.Link
                            as={Link}
                            to="/kdfs"
                            className={pathname.includes('/kdfs') ? 'active-nav' : ''}
                        >
                            KDFs
                        </Nav.Link>

                        {/* KDF Statistics (below KDFs when on kdf-stats) */}
                        {isKdfRoute && (
                            <Accordion defaultActiveKey="stats">
                                <Accordion.Item eventKey="stats">
                                    <Accordion.Header className="menu-sidebar active">
                                        KDF Statistics
                                    </Accordion.Header>
                                    <Accordion.Body className="p-0">
                                        <div className="statics-title-sub-item">
                                            {statsData?.doc?.title ?? window?.objInit?.doc?.title ?? '–'}
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        )}

                        <Nav.Link
                            as={Link}
                            to="/recipients"
                            className={pathname.includes('/recipients') ? 'active-nav' : ''}
                        >
                            Recipients
                        </Nav.Link>

                        <Nav.Link
                            as={Link}
                            to="/links"
                            className={pathname.includes('/links') ? 'active-nav' : ''}
                        >
                            LaserLINX
                        </Nav.Link>

                        {/* INSIGHT (below LaserLINX when on tl-stats) */}
                        {isLinkRoute && (
                            <Accordion defaultActiveKey="stats">
                                <Accordion.Item eventKey="stats">
                                    <Accordion.Header className="menu-sidebar active">
                                    LaserLINK Statistics
                                    </Accordion.Header>
                                    <Accordion.Body className="p-0">
                                        <div className="statics-title-sub-item">
                                            {statsData?.tl?.name ?? window?.objInit?.tl?.name ?? '–'}
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        )}

                        <Nav.Link onClick={() => setOpenSupport(true)}>
                            Support
                        </Nav.Link>

                    </Nav>
                </Container>
            </Navbar>
        </>
    );
};

export default SideBar;
